import { connect } from 'react-redux';
import AdminAnalyticsComponent from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.admin.analytics,
});

export default connect(mapStateToProps)(AdminAnalyticsComponent);
